import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs: FAQItem[] = [{
    question: '¿Esto reemplaza ir al médico?',
    answer: 'No. Esta guía es educativa e informativa. Está diseñada para que tengas más claridad, mejores hábitos y sepas cuándo sí es necesario consultar. No reemplaza el diagnóstico ni el tratamiento médico.'
  }, {
    question: '¿Necesito conocimientos médicos para entenderla?',
    answer: 'No. Fue escrita en lenguaje claro y accesible para cualquier mujer, sin importar su nivel de conocimiento sobre el tema.'
  }, {
    question: '¿Cómo la recibo?',
    answer: 'Al completar tu compra, recibes acceso inmediato para descargar el PDF completo con todos los bonos incluidos.'
  }, {
    question: '¿Sirve aunque nunca haya tenido candidiasis?',
    answer: 'Sí. También es útil como recurso preventivo y educativo para entender mejor la salud íntima femenina.'
  }, {
    question: '¿Qué pasa si tengo síntomas ahora mismo?',
    answer: 'La guía incluye una sección específica sobre qué hacer cuando los síntomas están presentes, y señales claras de cuándo buscar atención médica sin demora.'
  }, {
    question: '¿Y si ya sé bastante sobre el tema?',
    answer: 'La mayoría de mujeres que pensaban saber encuentran información nueva, conexiones que no habían hecho y herramientas como el diario de síntomas que les cambian el enfoque completamente.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 px-4 bg-bg-primary" data-id="element-45">
      <div className="max-w-4xl mx-auto" data-id="element-46">
        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-heading mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-47">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, index) => <motion.div key={index} className="bg-white rounded-2xl shadow-md overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-49">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-50">
                <span className="font-heading text-lg md:text-xl font-semibold text-heading pr-4" data-id="element-51">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-button flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-52" />
              </button>

              <AnimatePresence data-id="element-53">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-54">
                    <div className="px-6 pb-5 text-body text-lg leading-relaxed" data-id="element-55">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}